/* eslint-disable camelcase */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { reduxForm, Field, FieldArray } from 'redux-form';
import { get } from 'lodash';
import { compose } from 'redux';
import RichTextDisplay from '../../../components/RichTextDisplay';
import BasicTextArea from '../../../components/formComponents/groups/BasicTextArea';
import TrackPlayerSlideComponent from '../../../hocs/TrackPlayerSlideComponent';
import UserInviteList from './UserInviteList';

class UserInviteSlide extends Component {
    static propTypes = {
        currentUser: PropTypes.object,
        content: PropTypes.object,
        canMoveToNext: PropTypes.func,
        nextSectionName: PropTypes.string,
        partnershipMembers: PropTypes.arrayOf(
            PropTypes.shape({
                firstName: PropTypes.string,
                lastName: PropTypes.string,
                type: PropTypes.string
            })
        ),
        partnerAnswers: PropTypes.object,
        totalParticipants: PropTypes.number,
        completedData: PropTypes.object,
        onChange: PropTypes.func,
        name: PropTypes.string,
        currentSectionItemId: PropTypes.string,
        sendWorkspaceSegementEvent: PropTypes.func
    };

    constructor(props) {
        super(props);

        this.state = {
            totalMembersAndInvites: 0
        };
    }

    UNSAFE_componentWillMount() {
        const { canMoveToNext, onChange, currentSectionItemId, partnerAnswers, partnershipMembers } = this.props;
        const totalMembersAndInvites = this.getTotalMembersAndInvites(
            currentSectionItemId,
            partnerAnswers,
            partnershipMembers
        );

        if (canMoveToNext) {
            canMoveToNext(true);
        }
        if (onChange) {
            const isCompleted = true;
            const isAnswered = true;
            onChange(null, isCompleted, isAnswered);
        }

        this.setState({
            totalMembersAndInvites
        });
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        const { partnerAnswers, partnershipMembers } = this.props;

        if (partnerAnswers !== nextProps.partnerAnswers || partnershipMembers !== nextProps.partnershipMembers) {
            const setStateArgs = {
                currentSectionItemId: nextProps.currentSectionItemId,
                partnerAnswers: nextProps.partnerAnswers,
                partnershipMembers: nextProps.partnershipMembers
            };

            this.setState({
                totalMembersAndInvites: this.getTotalMembersAndInvites(setStateArgs)
            });
        }
    }

    getTotalMembersAndInvites = () => {
        const { currentSectionItemId, partnerAnswers = {}, partnershipMembers = [] } = this.props;

        let totalInvitedUsers = partnershipMembers.length;
        let currentPartnerData;

        Object.keys(partnerAnswers).forEach((key) => {
            currentPartnerData = partnerAnswers[key];
            totalInvitedUsers += get(currentPartnerData, `data.${currentSectionItemId}.data.users`, []).length;
        });

        return totalInvitedUsers;
    };

    render() {
        const {
            currentUser,
            partnershipMembers = [],
            name,
            nextSectionName,
            content = {},
            onChange,
            totalParticipants = 0,
            completedData = {},
            sendWorkspaceSegementEvent
        } = this.props;
        const { totalMembersAndInvites } = this.state;
        const { description } = content;

        return (
            <div>
                <h1 className={'verb-title-1 playerHeader'}>{name}</h1>
                <div className={'playerContent'}>
                    <RichTextDisplay
                        className={'playerDescription'}
                        htmlToDisplay={description}
                        currentUser={currentUser}
                        nextSectionName={nextSectionName}
                        partnershipMembers={partnershipMembers}
                    />
                    <form>
                        <FieldArray
                            name={'users'}
                            onChange={onChange}
                            completedData={completedData}
                            totalMembersAndInvites={totalMembersAndInvites}
                            totalParticipants={totalParticipants}
                            component={UserInviteList}
                        />
                        <Field
                            name={'message'}
                            labelTextId={'WORKSPACE_INVITE_ADD_NOTE'}
                            labelDefault={'Add a note'}
                            className={'col-md-12 userInviteNote'}
                            rows={3}
                            component={BasicTextArea}
                        />
                    </form>
                </div>
            </div>
        );
    }
}
export const UserInviteSlideComponent = UserInviteSlide;

const UserInviteSlideValidation = {
    form: 'UserInviteSlide',
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true
};

const mapStateToProps = (state, ownProps) => {
    const { completedData = {} } = ownProps;
    const { data = {} } = completedData;
    return {
        initialValues: {
            users: get(data, 'users', [{ email: '', name: '' }]),
            message: get(data, 'message', '')
        }
    };
};

export default TrackPlayerSlideComponent(
    compose(connect(mapStateToProps), reduxForm(UserInviteSlideValidation))(UserInviteSlide)
);
